// extracted by mini-css-extract-plugin
export default {"parent":"ScrollSnapper_parent__1xV2E","parentX":"ScrollSnapper_parentX__2po14","parentY":"ScrollSnapper_parentY__eVoB7","child":"ScrollSnapper_child__2aL68"};